import { useEffect, useState } from 'react';
import { isSSR } from 'src/helpers/ssr';
import { checkTouristsCountForMainPage } from 'src/utils/touristsUtils/touristsUtils';

/**
 * Данный хук отвечает за проверку количества туристов на допустимое значение
 * Он предназанчен для своевременного показа попапа про допустимое количество туристов,
 * когда динамическая сига ещё не активна, но попап должен показаться во время рендера превью сиги
 * @param searchType
 * @returns {initialAdults, initialKids, isTouristsLimitPopupShown, setTouristsLimitPopupShown,}
 */

export const useTouristsLimitCount = (searchType: string) => {
  const [isTouristsLimitPopupShown, setTouristsLimitPopupShown] =
    useState<boolean>(false);

  const [initialAdults, setInitialAdults] = useState<number>(2);
  const [initialKids, setInitialKids] = useState<number[]>([]);

  useEffect(() => {
    if (!isSSR) {
      const checkedTouriststCount = checkTouristsCountForMainPage(searchType);

      setInitialAdults(checkedTouriststCount.adults);
      setInitialKids(checkedTouriststCount.kids);
      setTouristsLimitPopupShown(checkedTouriststCount.limitPopupShown);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    initialAdults,
    initialKids,
    isTouristsLimitPopupShown,
    setTouristsLimitPopupShown,
  };
};
